import type { ReactNode } from "react";

// The neutral "nothing here" panel — same `.empty` markup as PageError
// but with no role="alert": an empty list is a state, not an event.
type Props = {
  title: string;
  description?: string;
  action?: ReactNode;
};

export function EmptyState({ title, description, action }: Props) {
  return (
    <div className="empty">
      <div className="empty__title">{title}</div>
      {description && <div className="empty__sub">{description}</div>}
      {action}
    </div>
  );
}
